import {formatToLocaleString} from "@/functions/numbers";

export function roundLength( length ): number {

	// First round the long tail to prevent floating point issues
	length = Math.round( length * 10000000 ) / 10000000;

	return Math.round( length * 100 ) / 100;
}

export function renderLength( length: number, unit = 'cm' ): string {
	length = roundLength( length );

	return formatToLocaleString( length ) + ' ' + unit;
}

export const renderMaxLength = roundLength;
